import { render, staticRenderFns } from "./CaseCoverUpload.vue?vue&type=template&id=d2968770"
import script from "./CaseCoverUpload.vue?vue&type=script&lang=js"
export * from "./CaseCoverUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports